(function () {
  document.documentElement.classList.remove('no-js');

  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var nav = document.querySelector('[data-mobile-nav]');
      var isOpen = nav && nav.getAttribute('data-open') === 'true';
      if (nav) nav.setAttribute('data-open', String(!isOpen));
      button.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('[data-mobile-shop-toggle]').forEach(function (button) {
    var menu = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu) return;
    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      var label = button.querySelector('[data-mobile-shop-label]');
      if (label) label.textContent = isOpen ? 'Shop Menu' : 'Close Menu';
    });
  });

  document.querySelectorAll('[data-quantity]').forEach(function (control) {
    var input = control.querySelector('input');
    control.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = button.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, Number(input.value || 1) + step);
        input.value = next;
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImage = gallery.querySelector('[data-product-main-image]');
    if (!mainImage) return;

    gallery.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();

        var fullSrc = thumb.getAttribute('data-full-src') || thumb.getAttribute('href');
        var srcset = thumb.getAttribute('data-srcset');
        if (!fullSrc) return;

        mainImage.setAttribute('src', fullSrc);
        if (srcset) {
          mainImage.setAttribute('srcset', srcset);
        }

        gallery.querySelectorAll('[data-product-thumb]').forEach(function (item) {
          item.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-product-options]').forEach(function (productOptions) {
    var productPage = productOptions.closest('.f40-product-page');
    var variantSelect = productOptions.querySelector('[data-product-variant-select]');
    var variantJson = productOptions.querySelector('[data-product-variants-json]');
    var colorIndex = Number(productOptions.getAttribute('data-color-option-index'));
    var sizeIndex = Number(productOptions.getAttribute('data-size-option-index'));
    var variants = [];

    if (variantJson) {
      try {
        variants = JSON.parse(variantJson.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    function currentVariant() {
      if (!variantSelect) return null;
      return variants.find(function (variant) {
        return String(variant.id) === String(variantSelect.value);
      }) || null;
    }

    function selectedColor() {
      var activeSwatch = productOptions.querySelector('[data-product-color-swatch].is-active');
      if (activeSwatch) return activeSwatch.getAttribute('data-color-name');
      var variant = currentVariant();
      return variant && colorIndex >= 0 ? variant.options[colorIndex] : null;
    }

    function selectedSize() {
      var activeSize = productOptions.querySelector('[data-product-size-option].is-active');
      if (activeSize) return activeSize.getAttribute('data-size-name');
      var variant = currentVariant();
      return variant && sizeIndex >= 0 ? variant.options[sizeIndex] : null;
    }

    function matchingVariant(color, size) {
      return variants.find(function (variant) {
        var colorMatches = colorIndex < 0 || !color || variant.options[colorIndex] === color;
        var sizeMatches = sizeIndex < 0 || !size || variant.options[sizeIndex] === size;
        return colorMatches && sizeMatches && variant.available;
      }) || variants.find(function (variant) {
        var colorMatches = colorIndex < 0 || !color || variant.options[colorIndex] === color;
        var sizeMatches = sizeIndex < 0 || !size || variant.options[sizeIndex] === size;
        return colorMatches && sizeMatches;
      }) || null;
    }

    function setVariant(variant) {
      if (!variant || !variantSelect) return;
      variantSelect.value = variant.id;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateSizeButtons(color) {
      productOptions.querySelectorAll('[data-product-size-option]').forEach(function (button) {
        var size = button.getAttribute('data-size-name');
        var variant = matchingVariant(color, size);
        button.disabled = !variant || !variant.available;
        if (variant) {
          button.setAttribute('data-variant-id', variant.id);
        }
      });
    }

    productOptions.querySelectorAll('[data-product-color-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;

        var colorName = swatch.getAttribute('data-color-name');
        var sizeName = selectedSize();
        var variant = matchingVariant(colorName, sizeName);
        if (!variant || !variant.available) {
          variant = matchingVariant(colorName, null);
        }
        var mainImages = productPage ? productPage.querySelectorAll('[data-product-main-image]') : [];
        var fullSrc = swatch.getAttribute('data-full-src');
        var srcset = swatch.getAttribute('data-srcset');
        var colorLabel = productPage && productPage.querySelector('[data-product-color-label]');

        setVariant(variant);
        updateSizeButtons(colorName);

        if (fullSrc) {
          mainImages.forEach(function (mainImage) {
            mainImage.setAttribute('src', fullSrc);
            if (srcset) {
              mainImage.setAttribute('srcset', srcset);
            }
          });
        }

        if (colorLabel && colorName) {
          colorLabel.textContent = colorName;
        }

        productOptions.querySelectorAll('[data-product-color-swatch]').forEach(function (item) {
          item.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        if (variant && sizeIndex >= 0) {
          productOptions.querySelectorAll('[data-product-size-option]').forEach(function (button) {
            button.classList.toggle('is-active', button.getAttribute('data-size-name') === variant.options[sizeIndex]);
          });
        }
      });
    });

    productOptions.querySelectorAll('[data-product-size-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        var variant = matchingVariant(selectedColor(), button.getAttribute('data-size-name'));
        setVariant(variant);

        productOptions.querySelectorAll('[data-product-size-option]').forEach(function (item) {
          item.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });
    });
  });
  document.querySelectorAll('[data-f40-filter-toggle]').forEach(function (button) {
    var drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('f40-filter-open');
      var closeButton = drawer.querySelector('[data-f40-filter-close]');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer() {
      drawer.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('f40-filter-open');
      button.focus();
    }

    button.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-f40-filter-close]').forEach(function (close) {
      close.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  });

  document.querySelectorAll('[data-f40-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('[data-f40-sort-form]');
      if (form) form.submit();
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.f40-quick-filter[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  var popup = document.querySelector('[data-first-order-popup]');
  if (popup) {
    var storageKey = 'forever40_first_order_popup_seen';
    var success = popup.querySelector('[data-popup-success]');
    var dismissed = false;
    try { dismissed = localStorage.getItem(storageKey) === 'true'; } catch (error) {}

    function closePopup() {
      popup.hidden = true;
      document.body.classList.remove('popup-open');
      try { localStorage.setItem(storageKey, 'true'); } catch (error) {}
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (button) {
      button.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    if (success) {
      popup.hidden = false;
      document.body.classList.add('popup-open');
      try { localStorage.setItem(storageKey, 'true'); } catch (error) {}
    } else if (!dismissed || (window.Shopify && Shopify.designMode)) {
      window.setTimeout(function () {
        popup.hidden = false;
        document.body.classList.add('popup-open');
        var email = popup.querySelector('input[type="email"]');
        if (email) email.focus();
      }, Number(popup.dataset.delay) || 4000);
    }
  }
})();

(function () {
  var overlay = document.querySelector('[data-f40-drawer-overlay]');
  var activeDrawer = null;
  var activeTrigger = null;

  function closeLuxuryDrawer() {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('f40-luxury-drawer-open');
    var drawerToHide = activeDrawer;
    window.setTimeout(function () { drawerToHide.hidden = true; }, 350);
    if (overlay) window.setTimeout(function () { overlay.hidden = true; }, 350);
    if (activeTrigger) activeTrigger.focus();
    activeDrawer = null;
    activeTrigger = null;
  }

  document.querySelectorAll('[data-f40-drawer-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var drawer = document.getElementById(trigger.getAttribute('data-f40-drawer-open'));
      if (!drawer) return;
      if (activeDrawer) closeLuxuryDrawer();
      activeDrawer = drawer;
      activeTrigger = trigger;
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('f40-luxury-drawer-open');
      var focusTarget = drawer.querySelector('input, a, button:not([data-f40-drawer-close])');
      if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 180);
    });
  });

  document.querySelectorAll('[data-f40-drawer-close]').forEach(function (button) {
    button.addEventListener('click', closeLuxuryDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeLuxuryDrawer);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLuxuryDrawer();
  });
})();


(function(){
  function focusables(container){return Array.prototype.slice.call(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){return el.offsetParent!==null;});}
  var opener=document.querySelector('[data-f40-mobile-menu-open]');
  var menu=document.querySelector('[data-f40-mobile-menu]');
  var lastFocus=null;
  function openMenu(){if(!menu)return;lastFocus=document.activeElement;var header=document.querySelector('[data-f40-site-header]');if(header){var bottom=Math.max(0,Math.round(header.getBoundingClientRect().bottom));document.documentElement.style.setProperty('--f40-mobile-menu-top',bottom+'px');}menu.hidden=false;opener&&opener.setAttribute('aria-expanded','true');document.body.classList.add('f40-mobile-menu-open');var items=focusables(menu);if(items[0])items[0].focus();}
  function closeMenu(){if(!menu)return;menu.hidden=true;opener&&opener.setAttribute('aria-expanded','false');document.body.classList.remove('f40-mobile-menu-open');if(lastFocus)lastFocus.focus();}
  if(opener&&menu){opener.addEventListener('click',openMenu);menu.querySelectorAll('[data-f40-mobile-menu-close]').forEach(function(b){b.addEventListener('click',closeMenu);});}
  document.addEventListener('keydown',function(e){
    var activeDialog=null;
    if(menu&&!menu.hidden)activeDialog=menu.querySelector('[role="dialog"]');
    document.querySelectorAll('[data-f40-filter-drawer]').forEach(function(drawer){if(!drawer.hidden)activeDialog=drawer.querySelector('[role="dialog"]');});
    if(e.key==='Escape'){if(menu&&!menu.hidden)closeMenu();return;}
    if(e.key==='Tab'&&activeDialog){var items=focusables(activeDialog);if(!items.length)return;var first=items[0],last=items[items.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
  });
})();


(function(){
  var grid=document.querySelector('[data-f40-product-grid]');
  var buttons=document.querySelectorAll('[data-f40-grid-view]');
  if(!grid||!buttons.length)return;
  var saved='comfortable';
  try{saved=sessionStorage.getItem('f40_product_grid_view')||'comfortable';}catch(e){}
  function setView(view){
    grid.classList.toggle('is-compact',view==='compact');
    buttons.forEach(function(button){var active=button.getAttribute('data-f40-grid-view')===view;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',active?'true':'false');});
    try{sessionStorage.setItem('f40_product_grid_view',view);}catch(e){}
  }
  buttons.forEach(function(button){button.addEventListener('click',function(){setView(button.getAttribute('data-f40-grid-view'));});});
  setView(saved);
})();
